import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { DSM3ModalService, DSM3SelectOption } from '@eredes/dsm3';
import { PodAndSupplierPartnerNumberContractResponse } from '@eredes/microservices';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

import { GeneralDataViewModel } from 'app/request-form/_models/general-data.view-model';

@Component({
  selector: 'app-general-data',
  templateUrl: './general-data.component.html',
  styleUrls: ['./general-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GeneralDataComponent implements OnInit {
  @Input() viewModel: GeneralDataViewModel;
  @Output() onChooseContract = new EventEmitter<any>();
  @Output() onCloseModalContract = new EventEmitter<any>();
  @ViewChild('templateModalNifOptions') templateModalNifOptions: TemplateRef<any>;
  modal: any;
  selectedContract: PodAndSupplierPartnerNumberContractResponse;
  contracts: PodAndSupplierPartnerNumberContractResponse[];
  selectedPartnerNumber = '';
  messageErrorPartnerNumber = '';
  nifOptions$: Subject<DSM3SelectOption[]> = new BehaviorSubject<DSM3SelectOption[]>([]);

  constructor(
    private readonly modalService: DSM3ModalService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.setupEventListeners();
  }

  /**
   * Method responsible for opening the modal with the list of NIFs
   */
  openModalAction(): void {
    if (!this.modal) {
      this.modal = this.modalService.custom(this.templateModalNifOptions, this.viewContainerRef);

      this.modal.onClose().subscribe(() => {
        this.onCloseModalContract.emit();

        this.modal = undefined;
        this.changeDetectorRef.detectChanges();
      });
    }
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Method responsible for closing the modal with the list of NIFs
   */
  closeModal(): void {
    this.onCloseModalContract.emit();
    this.modal.close();
    this.resetModal();
  }

  /**
   * Method responsible for making the necessary field updates after choosing a NIF (PartnerNumber)
   */
  choose(): void {
    this.onChooseContract.emit();
    this.closeModal();
  }

  /**
   * Method to convert a list of contracts to a list of DSM3SelectOption representing the list of NIFs
   */
  private mapperContractsToNifs(): void {
    if (!this.contracts) {
      return;
    }
    const nifs: DSM3SelectOption[] = this.contracts.map((item) => {
      let label = item.nif;

      if (item.contractContacts && item.contractContacts.length > 0) {
        const { firstName, lastName } = item.contractContacts[0];

        if (firstName) {
          label = `${label} - ${firstName} ${lastName ? lastName : ''}`;
        }
      }

      return {
        value: item.partner_number,
        label,
      };
    });

    this.nifOptions$.next(nifs);
  }

  /**
   * Method to initialize listeners for executing some flow in the component
   */
  private setupEventListeners(): void {
    this.viewModel.openModal.subscribe((value) => {
      if (value) {
        this.openModalAction();
      }
    });

    this.viewModel.contractsObs.subscribe((contracts: PodAndSupplierPartnerNumberContractResponse[]) => {
      this.contracts = contracts;
      this.mapperContractsToNifs();
      this.changeDetectorRef.detectChanges();
    });

    this.viewModel.formGroup.controls[this.viewModel.formNamePartnerNumber].valueChanges.subscribe((value: string) => {
      this.changeDetectorRef.detectChanges();
    });
  }

  /**
   * Method responsible for resetting the variable that controls the modal opening
   */
  private resetModal(): void {
    this.modal = undefined;
    this.changeDetectorRef.detectChanges();
  }
}
